import SamsungOrderInvoceService from './samsungOrderInvoicesService';

export default SamsungOrderInvoceService;
